var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMaestro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5218",
    "data-name": "Rectangle 5218",
    width: 112,
    height: 56,
    transform: "translate(1047 735)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_Maestro",
    transform: "translate(-1047 -735)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ms_vrt_rev",
    transform: "translate(1060.19 727.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5185",
    "data-name": "Rectangle 5185",
    width: 85.619,
    height: 70.374,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24628",
    "data-name": "Group 24628",
    transform: "translate(8.832 8.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54716",
    "data-name": "Path 54716",
    d: "M366.663,345.734v-3.5a2.073,2.073,0,0,0-2.19-2.213,2.157,2.157,0,0,0-1.957.99,2.045,2.045,0,0,0-1.841-.99,1.842,1.842,0,0,0-1.631.827v-.687h-1.212v5.569h1.223v-3.087a1.3,1.3,0,0,1,1.363-1.479c.8,0,1.212.524,1.212,1.468v3.1h1.223v-3.087a1.313,1.313,0,0,1,1.363-1.479c.827,0,1.223.524,1.223,1.468v3.1Zm6.827-2.784v-2.784h-1.212v.676a2.112,2.112,0,0,0-1.759-.815,2.928,2.928,0,0,0,0,5.848,2.112,2.112,0,0,0,1.759-.815v.676h1.212Zm-4.508,0a1.67,1.67,0,1,1,.454,1.261A1.686,1.686,0,0,1,368.982,342.95Zm30.433-2.931a3.14,3.14,0,0,1,1.2.224,2.914,2.914,0,0,1,.951.616,2.82,2.82,0,0,1,.628.927,3.093,3.093,0,0,1,0,2.326,2.817,2.817,0,0,1-.628.928,2.912,2.912,0,0,1-.951.616,3.3,3.3,0,0,1-2.39,0,2.883,2.883,0,0,1-.948-.616,2.847,2.847,0,0,1-.625-.928,3.1,3.1,0,0,1,0-2.326,2.847,2.847,0,0,1,.625-.927,2.884,2.884,0,0,1,.948-.616A3.139,3.139,0,0,1,399.415,340.019Zm0,1.146a1.808,1.808,0,0,0-.692.131,1.637,1.637,0,0,0-.552.366,1.708,1.708,0,0,0-.366.564,2.027,2.027,0,0,0,0,1.448,1.707,1.707,0,0,0,.366.564,1.637,1.637,0,0,0,.552.366,1.9,1.9,0,0,0,1.384,0,1.67,1.67,0,0,0,.555-.366,1.69,1.69,0,0,0,.369-.564,2.026,2.026,0,0,0,0-1.448,1.692,1.692,0,0,0-.369-.564,1.67,1.67,0,0,0-.555-.366A1.809,1.809,0,0,0,399.415,341.165Zm-19.332,1.785a2.67,2.67,0,0,0-2.644-2.924,2.927,2.927,0,0,0,.081,5.848,3.384,3.384,0,0,0,2.283-.781l-.594-.9a2.654,2.654,0,0,1-1.619.582,1.547,1.547,0,0,1-1.666-1.363h4.136C380.071,343.265,380.083,343.113,380.083,342.95Zm-4.147-.489a1.434,1.434,0,0,1,1.48-1.351,1.383,1.383,0,0,1,1.41,1.351Zm9.25-.874a3.59,3.59,0,0,0-1.736-.478c-.664,0-1.06.245-1.06.652,0,.373.419.477.944.547l.571.082c1.212.175,1.945.687,1.945,1.666,0,1.06-.932,1.818-2.54,1.818a4.017,4.017,0,0,1-2.411-.722l.571-.943a2.966,2.966,0,0,0,1.852.582c.827,0,1.27-.245,1.27-.676,0-.315-.315-.489-.979-.582l-.571-.082c-1.246-.175-1.922-.734-1.922-1.643,0-1.107.909-1.782,2.318-1.782a4.163,4.163,0,0,1,2.272.583Zm5.822-.315h-1.98v2.516c0,.559.2.932.8.932a2.237,2.237,0,0,0,1.072-.315l.349,1.037a2.846,2.846,0,0,1-1.514.431c-1.433,0-1.934-.769-1.934-2.062v-2.54h-1.13v-1.107h1.13v-1.689h1.223v1.689h1.98Zm4.193-1.247a2.586,2.586,0,0,1,.862.152l-.373,1.142a1.973,1.973,0,0,0-.757-.14c-.792,0-1.188.513-1.188,1.433v3.122h-1.212v-5.569h1.2v.676A1.642,1.642,0,0,1,395.2,340.026Zm8.388,4.9a.557.557,0,0,1,.219.044.57.57,0,0,1,.179.119.559.559,0,0,1,.121.177.544.544,0,0,1,0,.43.562.562,0,0,1-.121.176.579.579,0,0,1-.179.119.549.549,0,0,1-.219.044.565.565,0,0,1-.524-.339.546.546,0,0,1,0-.43.556.556,0,0,1,.3-.3.574.574,0,0,1,.223-.043Zm0,.986a.412.412,0,0,0,.167-.034.44.44,0,0,0,.136-.092.432.432,0,0,0-.136-.7.417.417,0,0,0-.167-.033.435.435,0,0,0-.17.033.424.424,0,0,0-.138.092.432.432,0,0,0,.308.738Zm.033-.691a.234.234,0,0,1,.153.044.147.147,0,0,1,.054.12.14.14,0,0,1-.043.105.2.2,0,0,1-.122.051l.168.194H403.7l-.156-.193h-.05v.193h-.11v-.515Zm-.128.1v.137h.126a.124.124,0,0,0,.069-.017.058.058,0,0,0,.026-.052.057.057,0,0,0-.026-.051.124.124,0,0,0-.069-.017Z",
    transform: "translate(-346.119 -293.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24627",
    "data-name": "Group 24627"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5186",
    "data-name": "Rectangle 5186",
    width: 18.375,
    height: 33.02,
    transform: "translate(24.79 4.49)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54717",
    "data-name": "Path 54717",
    d: "M363.709,281.817a20.963,20.963,0,0,1,8.021-16.51,21,21,0,1,0,0,33.02A20.964,20.964,0,0,1,363.709,281.817Z",
    transform: "translate(-337.753 -260.816)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54718",
    "data-name": "Path 54718",
    d: "M450.509,318.543v-.676h.273v-.138h-.694v.138h.273v.676Zm1.348,0v-.815h-.213l-.245.561-.245-.561h-.213v.815h.15v-.615l.23.53h.156l.23-.531v.616Z",
    transform: "translate(-384.559 -284.529)",
    fill: "#00a2e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54719",
    "data-name": "Path 54719",
    d: "M429.976,281.817A21,21,0,0,1,396,298.327a21,21,0,0,0,0-33.02,21,21,0,0,1,33.976,16.51Z",
    transform: "translate(-362.022 -260.817)",
    fill: "#d8d8d8"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaestro);
export default __webpack_public_path__ + "static/media/logo_Maestro.27617272149d5111759d28abb907bd7b.svg";
export { ForwardRef as ReactComponent };